export default "__VITE_ASSET__k9ZJ9mRa__"